import { useEffect, useState } from 'react'
import { GetAvailabilityFiltersNames } from '../../../Services/ProductService'
import { useConfig } from '../../../Providers/ConfigProvider'
import axios from 'axios'

const useGetAvailabilityFiltersNames = () => {
    const { api } = useConfig()
    const [availabilityFiltersNames, setAvailabilityFiltersNames] = useState([])

    useEffect(() => {
        const source = axios.CancelToken.source()

        GetAvailabilityFiltersNames(api, source.token).then(res => {
            setAvailabilityFiltersNames(res.data)
        })
            .catch(e => {
                if (axios.isCancel(e)) {
                    console.log(e)
                    setAvailabilityFiltersNames([])
                }
            })
        return () => {
            source.cancel()
        }
    }, [JSON.stringify(api)])

    return { availabilityFiltersNames }
}

export default useGetAvailabilityFiltersNames